import { useEffect, useState } from "react";
import moment from "moment";
import ReactTableComponent from "../../UniversalComponents/ReactTableComponent";
import ToolTipComponent from "../../UniversalComponents/ToolTipComponent";
import PlusIcon from "../../../assets/images/icons/PlusIcon";
import { deletePermission, fetchManagePermission } from "../../../utils/api/managePermissionApi";
import DeleteIcon from "../../../assets/images/icons/deleteIcon";
import { getCompanyId } from "../../../utils/utilityFunctions/localServices";
import { useDispatch } from "react-redux";
import PermissionModuleOptions from "./PermissionModuleOptions";
import { pushAlert } from "../../../utils/alertSlice";
import ConfirmationDialogBox from "../../UniversalComponents/ConfirmationDialogMulti";
import { hideLoader, showLoader } from "../../../utils/loaderSlice";
import { ReactComponent as NoPermission } from "../../../assets/images/Nopermission.svg";
import { useParams } from "react-router-dom";

const Permission = ({ TabSwitch }) => {
  const dispatch = useDispatch();
  const [isPermissionDrawerOpen, setIsPermissionDrawerOpen] = useState(false);
  const [permissionsTableData, setPermissionsTableData] = useState([]);
  const [errorFields, setErrorFields] = useState({ name: false, description: false });
  const [refetchPermissionList, setReFetchPermissionList] = useState(false);
  const [updateCounter, setUpdateCounter] = useState(0);
  const [selectedDataToBeDeteted, setSelectedDataToBeDeleted] = useState(null);
  const [isApiLoading, setIsApiLoading] = useState(false);
  const data = useParams();
  const [formData, setFormData] = useState({ name: "", description: "", organisationView: [] });

  const HEADER_CONFIG = [
    {
      accessor_key: "name",
      label: "Name",
      callingFunction: (item) => {
        getPermissionsList(item?.permission_id);
        setIsPermissionDrawerOpen(true);
        setFormData(item);
      },
    },
    {
      accessor_key: "description",
      label: "Descripton",
    },
    {
      accessor_key: "created_by",
      label: "Created By",
      // callingFunction: () => {},
    },
    {
      accessor_key: "created_date",
      label: "Created Date",
      // callingFunction: () => {},
    },
  ];

  const fetchPermissionData = async () => {
    setIsApiLoading(true);
    const permissionResponseData = await fetchManagePermission({
      query: {
        company_id: data?.id || getCompanyId(),
        key: "permission",
      },
    });
    setPermissionsTableData(
      permissionResponseData?.data?.map((data) => {
        return {
          ...data,
          name: data?.permission_name,
          description: data?.permission_description,
          created_by: data?.first_name + " " + data?.last_name,
          created_date: data?.created_at && moment(data?.created_at).format("MMM D, YYYY"),
        };
      })
    );

    setIsApiLoading(false);
  };

  const getPermissionsList = async (permission_id = null) => {
    setIsApiLoading(true);
    const permissionResponseData = await fetchManagePermission({
      query: {
        company_id: data?.id || getCompanyId(),
        key: "single_permission",
        permission_id,
      },
    });

    setFormData(
      permissionResponseData?.data?.map((data) => {
        return {
          ...data,
          name: data?.permission_name,
          description: data?.permission_description,
          organisationView: data?.modules,
        };
      })[0]
    );
    setIsApiLoading(false);
  };

  const handleDeletePermission = async (item) => {
    setIsApiLoading(true);
    try {
      const deleteGroupResponse = await deletePermission({
        body: { permission_id: item?.permission_id, company_id: data?.id || getCompanyId() },
      });
      if (deleteGroupResponse?.success) {
        dispatch(
          pushAlert({
            visible: true,
            message: "Permission Deleted Successfully",
            type: "success",
          })
        );
        fetchPermissionData();
      } else {
        dispatch(
          pushAlert({
            visible: true,
            type: "danger",
            message: deleteGroupResponse?.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          type: "danger",
          message: error?.message,
        })
      );
    } finally {
      setIsApiLoading(false);
    }
  };

  const handleDeletePermissionDialogConfirmation = async (selectedDataToBeDeteted) => {
    setUpdateCounter((prevCounter) => prevCounter + 1);
    dispatch(
      pushAlert({
        type: "revert",
        message: "",
        visible: true,
        counter: updateCounter,
        onConfirm: () => {
          handleDeletePermission(selectedDataToBeDeteted);
          setSelectedDataToBeDeleted(null);
        },
        onRevert: () => {
          setSelectedDataToBeDeleted(null);
        },
      })
    );
  };

  useEffect(() => {
    fetchPermissionData();
  }, [refetchPermissionList]);

  useEffect(() => {
    if (isApiLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
  }, [isApiLoading]);

  return (
    <div className="min-w-0 grow ">
      <ConfirmationDialogBox
        onConfirm={() => {
          setSelectedDataToBeDeleted(null);
          handleDeletePermissionDialogConfirmation(selectedDataToBeDeteted);
        }}
        open={selectedDataToBeDeteted}
        onClose={() => setSelectedDataToBeDeleted(null)}
        message={"Do you want to delete this permission?"}
        iconVariant="delete"
        confirmVariant="delete"
        confirmText="Delete"
        cancelText="Cancel"
      />
      {!isPermissionDrawerOpen ? (
        <ReactTableComponent
          // apiLoadingState={}
          tablename={<TabSwitch />}
          alternateDiv={
            <div className="w-full h-full">
              <div className="flex justify-center items-center flex-col space-y-2 h-full ">
                <NoPermission className="w-[300px] h-[300px]" />
                <span className="text-[#000000] font-poppins font-500 text-14">Manage Permission</span>
              </div>
            </div>
          }
          body={permissionsTableData || []}
          // tablename={<p className="text-2C495D font-600">Permission</p>}
          headers={HEADER_CONFIG}
          isHyperLinkBold
          actionField={
            <div className="flex items-center h-full">
              <div className="flex items-center ml-1 cursor-pointer">
                <ToolTipComponent text="Add Permission" style={{ color: "#1D4469" }}>
                  <span
                    onClick={() => {
                      setIsPermissionDrawerOpen(true);
                      setFormData({ name: "", description: "", organisationView: [] });
                    }}
                    className="cursor-pointer border border-[#EBF2F6] rounded-md hover:bg-[#CECECE4D] hover:border-transparent"
                  >
                    <PlusIcon />
                  </span>
                </ToolTipComponent>
              </div>
            </div>
          }
          actionColumn={(item) => {
            return (
              <div className="flex items-center gap-2">
                <button
                  onClick={() => {
                    setSelectedDataToBeDeleted(item);
                  }}
                >
                  <DeleteIcon color={"red"} size={18} />
                </button>
              </div>
            );
          }}
        />
      ) : (
        <>
          <PermissionModuleOptions
            formData={formData}
            setFormData={setFormData}
            setErrorFields={setErrorFields}
            refetchApi={fetchPermissionData}
            onClose={() => setIsPermissionDrawerOpen(false)}
            errorFields={errorFields}
            permissionsTableData={permissionsTableData}
          />
        </>
      )}
    </div>
  );
};

export default Permission;
